import React from 'react';
import {Switch, BrowserRouter as Router, Redirect, Route} from 'react-router-dom';
import HomePage from "@pages/HomePage";
import ProductPage from "@pages/ProductPage";
import ScrollToTop from '@router/ScrollToTop';
import SuccessPage from "@pages/SuccessPage";

const Routes = () => {
  return (
    <Router>
      <ScrollToTop/>
      <Switch>
        <Route exact path="/" component={HomePage}/>
        <Route exact path="/product/:id" component={ProductPage}/>
        <Route exact path="/reservation-success" component={SuccessPage}/>
        <Redirect from="*" to="/"/>
      </Switch>
    </Router>
  );
};

export default Routes;
